import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'

import { Card as MuiCard, Grid, Typography } from '@material-ui/core'
import { spacing } from '@material-ui/system'
import { ChevronRight as ChevronRightIcon } from '@material-ui/icons'

import { urlFor } from '../../routes'

const Card = styled(MuiCard)(spacing)

const LocationWrapper = styled(Card)`
  border: 1px solid ${(props) => props.theme.palette.grey[300]};
  margin-bottom: ${(props) => props.theme.spacing(4)}px;
  cursor: pointer;
  display: flex;

  &:hover {
    background: ${(props) => props.theme.body.background};
  }
`

const LocationLabelWrapper = styled.div`
  margin: 6px;
`

interface HierarchyPathProps {
  location: { objPath: { guid: string; name: string; icon: React.FC }[] }
  title: string
}

const CompactPath = (props: HierarchyPathProps) => {
  const { location, title } = props
  return (
    <Grid container>
      {!!title && <Grid item>{title}</Grid>}
      {location &&
        location.objPath.map((ancestor, index, arr) => {
          const Icon = ancestor.icon || null
          const url = urlFor(ancestor)
          return (
            <React.Fragment key={ancestor.guid}>
              <Grid item>
                <Link to={url as string}>
                  <LocationWrapper>
                    <Icon />
                    <LocationLabelWrapper>{ancestor.name}</LocationLabelWrapper>
                  </LocationWrapper>
                </Link>
              </Grid>
              <Grid item>
                {index + 1 < arr.length && (
                  <Typography>
                    {' '}
                    <ChevronRightIcon />{' '}
                  </Typography>
                )}
              </Grid>
            </React.Fragment>
          )
        })}
    </Grid>
  )
}

export default CompactPath
